import React from 'react'
import { Link, withRouter } from 'react-router-dom'
import Dialog from '../../../../components/dialog/dialog.component'
import Loading from '../../../../components/loading/loading.component'
import FormHelper from '../../../../utils/FormHelper'
import PageForm from '../components/form/form.component'
import EditPageWorker from './edit'
import './edit.styles.scss'

class EditPage extends React.Component {

    constructor(props) {
        super(props)
        this.editPageWorker = EditPageWorker(this)
        this.state = this.editPageWorker.getDefaultState()
    }

    componentDidMount() {
        this.editPageWorker.loadPage()
    }

    onSubmit = (event) => {
        event.preventDefault()
        if (!this.editPageWorker.isValid()) {
            return
        }

        this.editPageWorker.updatePage()
    }

    onCancel = (event) => {
        event.preventDefault()
        this.props.history.push('/content/pages')
    }

    render() {
        return (
            <div className="edit-page">
                {
                    (this.state.loadingPage || this.state.updatingPage) && <Dialog><Loading /></Dialog>
                }
                <div className="card">
                    <Link className="btn" to="/content/pages">Pages</Link>
                    <div className="header">
                        <h4>Edit Page</h4>
                    </div>

                    <div className={"flag " + this.state.flag.type}>{this.state.flag.text}</div>

                    <PageForm
                        {...this.state}
                        action="Save Page"
                        submitting={this.state.updatingPage}
                        onChange={FormHelper(this).onChange}
                        onSubmit={this.onSubmit}
                        onCancel={this.onCancel}
                    />
                </div>
            </div>
        )
    }
}

export default withRouter(EditPage)
